import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { PT_SERIF } from '../../styles/typography'

const StyledVideoWrapper = styled.div`
  position: relative;
`;

const StyledVideoAspect = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 8px;
  &::before {
    content: '';
    display: block;
    padding-bottom: 62.5%;
  }
`;

const StyledVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const StyledCaption = styled.span`
  font-size: 16px;
  font-family: ${PT_SERIF};
  text-align: right;
  display: block;
`;

const Video = ({src, caption, className}) => {
  return (
    <StyledVideoWrapper className={className}>
      <StyledVideoAspect>
        <StyledVideo loop autoPlay muted>
          <source src={src}/>
        </StyledVideo>
      </StyledVideoAspect>
      {caption && <StyledCaption>{caption}</StyledCaption>}
    </StyledVideoWrapper>
  )
}

Video.propTypes = {
  src: PropTypes.string.isRequired,
  caption: PropTypes.string,
}

export default Video
